// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3himd","label":"styles_label__28lZO"};